import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/explore.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm explore <pkg> [ -- <command>]
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/explore.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <p>{`Note: This command is unaware of workspaces.`}</p>
    <h3>{`Description`}</h3>
    <p>{`Spawn a subshell in the directory of the installed package specified.`}</p>
    <p>{`If a command is specified, then it is run in the subshell, which then
immediately terminates.`}</p>
    <p>{`This is particularly handy in the case of git submodules in the
`}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` folder:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm explore some-dependency -- git pull origin master
`}</code></pre>
    <p>{`Note that the package is `}<em parentName="p">{`not`}</em>{` automatically rebuilt afterwards, so be
sure to use `}<inlineCode parentName="p">{`npm rebuild <pkg>`}</inlineCode>{` if you make any changes.`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`shell`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: SHELL environment variable, or "bash" on Posix, or "cmd.exe" on
Windows`}</li>
      <li parentName="ul">{`Type: String`}</li>
    </ul>
    <p>{`The shell to run for the `}<inlineCode parentName="p">{`npm explore`}</inlineCode>{` command.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/folders"
        }}>{`npm folders`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-edit"
        }}>{`npm edit`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-rebuild"
        }}>{`npm rebuild`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-install"
        }}>{`npm install`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      